const actions = {
  SET_USER: "SET_USER",
  CLEAR_USER: "CLEAR_USER",
}

export { actions }
